import { Box, Typography, Grid, Table, TableBody, TableRow, TableCell, Divider } from '@mui/material';
import FactoryIcon from '@mui/icons-material/Factory';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTheme } from '@mui/material';
import type { Manufacturer } from '../../context/ManufacturerContext';

interface ManufacturerInfoProps {
  manufacturer: Manufacturer;
}

export function ManufacturerInfo({ manufacturer }: ManufacturerInfoProps) {
  const theme = useTheme();

  return (
    <>
      <Typography fontWeight={700} fontSize={18} color={theme.palette.text.primary} mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FactoryIcon sx={{ color: theme.palette.primary.main, fontSize: 22 }} /> Informações do Fabricante
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, width: 140, border: 'none' }}>
                  Nome
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <LocationOnIcon sx={{ fontSize: 16 }} />
                    Endereço
                  </Box>
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.address}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Descrição
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.description}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, width: 140, border: 'none' }}>
                  Empresa
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.tenant_name || '-'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Criado em
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.createdAt ? new Date(manufacturer.createdAt).toLocaleDateString('pt-BR') : '-'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.secondary, border: 'none' }}>
                  Atualizado em
                </TableCell>
                <TableCell sx={{ fontWeight: 500, color: theme.palette.text.primary, border: 'none' }}>
                  {manufacturer.updatedAt ? new Date(manufacturer.updatedAt).toLocaleDateString('pt-BR') : '-'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
} 